exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filtro {\n  font-style: italic; }\n\n.error {\n  color: red; }\n\n.tabla {\n  max-height: 60vh;\n  overflow-y: auto; }\n\n.nowrap {\n  white-space: nowrap; }\n\n.fichaje {\n  font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/theme/components/modals/components/modalHistorialRH/modalHistorialRH.scss
// module id = ../../../../../src/app/theme/components/modals/components/modalHistorialRH/modalHistorialRH.scss
// module chunks = 14